<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="title"
    @hide="onDialogHide"
    @submit="onSubmitForm"
  >
    <div class="row q-col-gutter-md">
      <p class="col-12 q-ma-none">
        {{ subTitle }}
      </p>
      <TagSelect
        v-model="selectedTags"
        outlined
        class="col-12"
        :limit-tags="currentTags.length > 0 ? currentTags : null"
      />
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <hr-confirm-btn
        type="submit"
        :label="submitButtonLabel"
      />
    </template>
  </hr-form-dialog>
</template>

<script setup>
import TagSelect from 'components/Tags/TagSelect';
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrFormDialog,
} from 'src/design-system';
import { ref } from 'vue';

defineOptions({
  name: 'TagSelectDialog',
});

defineProps({
  title: {
    type: String,
    required: true,
  },
  subTitle: {
    type: String,
    required: true,
  },
  submitButtonLabel: {
    type: String,
    required: true,
  },
  isRemoving: {
    type: Boolean,
    default: false,
  },
  currentTags: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['hide', 'ok']);

const dialog = ref(null);
const selectedTags = ref([]);

const show = () => {
  dialog.value.show();
};

const hide = () => {
  if (dialog.value) {
    dialog.value.hide();
  }
};

const onDialogHide = () => {
  emit('hide');
};

const onSubmitForm = () => {
  emit('ok', { selectedTags: selectedTags.value });
  hide();
};

defineExpose({ show, hide });
</script>
